export default [
  // {
  //   path: '/school/list',
  //   name: 'school-list',
  //   component: () => import('@/views/school/list/SchoolList.vue'),
  //   meta: {
  //     resource: 'school',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/class/list',
  //   name: 'class-list',
  //   component: () => import('@/views/class/list/ClassList.vue'),
  //   meta: {
  //     resource: 'class',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/student/list',
  //   name: 'student-list',
  //   component: () => import('@/views/student/list/StudentList.vue'),
  //   meta: {
  //     resource: 'student',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/fee/list',
  //   name: 'fee-list',
  //   component: () => import('@/views/fee/list/FeeList.vue'),
  //   meta: {
  //     resource: 'fee',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/fee-category/list',
  //   name: 'fee-category-list',
  //   component: () => import('@/views/fee-category/list/FeeCategoryList.vue'),
  //   meta: {
  //     resource: 'fee-category',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/income-expense/list',
  //   name: 'income-expense-list',
  //   component: () => import('@/views/finance/income_expense/list/IncomeExpenseList.vue'),
  //   meta: {
  //     resource: 'income-expense',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/invoice/list',
  //   name: 'invoice-list',
  //   component: () => import('@/views/finance/invoice/list/InvoiceList.vue'),
  //   meta: {
  //     resource: 'invoice',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/release-invoice/list-new',
  //   name: 'release-invoice-list-new',
  //   component: () => import('@/views/finance/release_invoice/test/ReleaseInvoiceListTest.vue'),
  //   meta: {
  //     resource: 'release-invoice',
  //     action: 'read'
  //   }
  // },
  // {
  //   path: '/release-invoice/detail',
  //   name: 'release-invoice-detail',
  //   component: () => import('@/views/finance/release_invoice/test/ReleaseInvoiceListTest.vue'),
  //   meta: {
  //     resource: 'release-invoice',
  //     action: 'read'
  //   }
  // },
  // {
  //   path: '/release-invoice/comparison',
  //   name: 'release-invoice-comparison',
  //   component: () => import('@/views/finance/release_invoice/test/ReleaseInvoiceListTest.vue'),
  //   meta: {
  //     resource: 'release-invoice',
  //     action: 'read'
  //   }
  // },
  {
    path: '/report/report-by-service-type',
    name: 'report-by-service-type-1',
    component: () => import('@/views/report/report-by-service-type/ReportByServiceType.vue'),
    meta: {
      resource: 'report-by-service-type',
      action: 'read',
    },
  },
  {
    path: '/report/report-by-service-type',
    name: 'report-by-service-type-2',
    component: () => import('@/views/report/report-by-service-type/ReportByServiceType.vue'),
    meta: {
      resource: 'report-by-service-type',
      action: 'read',
    },
  },
  {
    path: '/report/report-by-service-type',
    name: 'report-by-service-type-3',
    component: () => import('@/views/report/report-by-service-type/ReportByServiceType.vue'),
    meta: {
      resource: 'report-by-service-type',
      action: 'read',
    },
  },
  {
    path: '/report/report-by-service-type',
    name: 'report-by-service-type-4',
    component: () => import('@/views/report/report-by-service-type/ReportByServiceType.vue'),
    meta: {
      resource: 'report-by-service-type',
      action: 'read',
    },
  },
];
